import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { useParams } from 'react-router-dom';

import { ImageThumb } from 'utils/helpers';

const AStylised = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  color: 'black',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'none',
    ' .rd-card-content': {
      minHeight: '100% !important',
    },
  },
  '& .rd-card': {
    marginRight: theme.spacing(2),
    borderRadius: 0,
    border: 'none',
    boxShadow: 'none',
    '& .rd-card-img': {
      height: 290,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .rd-card-content': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      minHeight: '40px',
      height: theme.spacing(3),
      backgroundColor: 'rgba(0,0,0, .6)',
      color: theme.palette.primary.contrastText,
      transition: '.12s ease-in-out',
      wordBreak: 'break-word',
      lineHeight: 1.5,
    },
  },
}));

const RecentDevelopmentItem = (props) => {
  const { lang } = useParams();
  const { stat } = props;

  const rdId = (urlValue) => {
    if (!isEmpty(urlValue)) {
      return urlValue.replace(`/${lang}/instruments/`, '').replaceAll('-', '/');
    }
    return null;
  };

  return (
    <AStylised href={stat.link} target={'_blank'}>
      <Card className='rd-card'>
        <CardActionArea>
          <CardMedia className='rd-card-img'>
            <ImageThumb src={`${stat.imgUrl}`} styles={{ height: '100%', maxWidth: '100%' }}/>
          </CardMedia>
          <CardContent className='rd-card-content'>
            <Typography variant='p' component='div'>
              {rdId(stat.link)}
            </Typography>
            <Typography variant='p' component='div' sx={{ mt: 2 }}>
              {rdId(stat.name)}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </AStylised>
  );
};

export default RecentDevelopmentItem;
